import React from 'react';
import TemplateConfirmation from '../../components/TemplateConfirmation';
export function TemplateConfirmationLinkApi(_a) {
    var linkApiResponse = _a.linkApiResponse, onSubmit = _a.onSubmit;
    return (React.createElement(TemplateConfirmation, { title: linkApiResponse.template.title, subtitle: linkApiResponse.template.subtitle, detailsTable: linkApiResponse.template.detailsTable, confirmCheckbox: linkApiResponse.template.confirmCheckbox, buttonText: linkApiResponse.template.buttonText, onSubmit: onSubmit }));
}
export default TemplateConfirmationLinkApi;
